import React from 'react'
import { View } from 'react-native'
import { useStyles } from './border-separator.styles'
import type { BorderSeparatorProps } from './border-separator.props'

export const BorderSeparator = (props: BorderSeparatorProps) => {
  const styles = useStyles(props)

  return (
    <View
      style={styles.container}
      testID='border-separator'
    />
  )
}
